import type { IVideoSrcParserOptions } from "../types";
import { parseOpts } from "./parseOpts";

export const getLoomEmbedSrc = (
  url: string,
  opts: IVideoSrcParserOptions = {},
  isPdf = false,
) => {
  const baseUrl = "https://www.loom.com/embed/";
  const regex = /(share|embed)\/([\w\d]+)/;
  const match = url.match(regex);

  let result = "";
  if (match && match.length > 1) {
    const videoId = match[match.length - 1];
    result = baseUrl + videoId;
  }

  const { controls, autoplay, loop } = parseOpts(opts, isPdf);

  result = result.replace(
    /[&?]?(hide_owner|hide_share|hide_title|hideEmbedTopBar|mute|autoplay|loop)=\d/gm,
    "",
  );
  const s: string[] = [];
  if (isPdf) s.push(`t=0`);
  s.push(`hide_owner=${controls ? 0 : 1}`);
  s.push(`hide_share=${controls ? 0 : 1}`);
  s.push(`hide_title=${controls ? 0 : 1}`);
  s.push(`hideEmbedTopBar=${controls ? 0 : 1}`);
  s.push(`autoplay=${autoplay ? 1 : 0}`);
  s.push(`loop=${loop ? 1 : 0}`);
  s.push(`mute=1`);

  return result + `?${s.join("&")}`;
};
